import moment from 'moment';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dateUTCToLocale } from 'src/common/helpers/utcToLocale';

// Interfaces
import { PSessionsI } from 'src/interfaces/coach/wellness';

const Session = (props: PSessionsI) => {
  const { session, opacity, pastSessions } = props;
  const [timeRemaining, setTimeRemaining] = useState<string>(session?.timeRemaining || '');

  const responsesArray = JSON.parse(session.surveyResponse);
  const appointmentDate = session?.startDate;
  const newArray: Array<string> = [];
  const { t } = useTranslation(['wellness']);

  // Calculate and update the time remaining for upcoming sessions
  useEffect(() => {
    if (pastSessions || !appointmentDate) return;

    const calculateTimeRemaining = () => {
      const now = moment();
      const localTime = dateUTCToLocale(appointmentDate);
      const sessionTime = moment(localTime);

      if (sessionTime.isBefore(now)) return '00:00:00';

      const duration = moment.duration(sessionTime.diff(now));
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`;
    };

    setTimeRemaining(calculateTimeRemaining());
    const timer = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    return () => clearInterval(timer);
  }, [appointmentDate, pastSessions]);

  const handleResponseValues = () => {
    responsesArray?.[0].answers.map((value: string) => {
      if (value === 'RelationshipIssues') newArray.push(t('session.relIssues'));
      if (value === 'FamilyIssues') newArray.push(t('session.famIssues'));
      if (value === 'PersonalIssues') newArray.push(t('session.personalIssues'));
      if (value === 'Other') newArray.push(t('session.otherIssues'));
    });
    return newArray.length > 0 ? newArray.join(', ') : t('session.noTopic');
  };

  const parseTimeRemaining = (time: string): number => {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return hours * 60 + minutes + seconds / 60;
  };

  const handleJoinMeeting = () => {
    if (session?.meetingUrl) {
      window.open(session.meetingUrl, '_blank');
    }
  };

  console.log('time ', timeRemaining, parseTimeRemaining(timeRemaining));

  return (
    <div className='flex items-center w-full'>
      <div className='w-5/6 flex flex-col items-start ml-0 sm:ml-4 mr-4'>
        <div className={`font-semibold pb-2 text-left ${opacity ? 'opacity-70' : ''}`}>
          {`${t('session.durationFirst')} ${session.duration} ${t('session.durationLast')}`}
        </div>
        <div className={`text-left text-xs sm:text-sm ${opacity ? 'opacity-70' : ''}`}>
          <p>
            <b className='font-medium pr-1'>{t('session.when')}</b>
            {dateUTCToLocale(session.startDate, 'DD MMM YYYY')}
            <span className='mx-0 sm:mx-1'> / </span>
            {dateUTCToLocale(session.startDate, 'hh:mm')} <span> - </span>
            {dateUTCToLocale(session.endDate, 'hh:mm A')}
          </p>
        </div>
        <div className={`text-left mr-2 text-xs sm:text-sm ${opacity ? 'opacity-70' : ''}`}>
          <b className='font-medium pr-1'>{t('session.with')}</b>
          {`${session.userFullName}`}
        </div>
        <div className={`text-left mr-2 text-xs sm:text-sm ${opacity ? 'opacity-70' : ''}`}>
          <b className='font-medium pr-1'>{t('session.topic')}</b>
          {handleResponseValues()}
        </div>
      </div>
      <div>
        {!pastSessions && (
          <button
            onClick={handleJoinMeeting}
            className={`text-grey-400 text-m font-medium rounded-md ${
              timeRemaining && parseTimeRemaining(timeRemaining) < 15
                ? 'text-blue-900'
                : 'opacity-50 cursor-not-allowed'
            }`}
            disabled={!timeRemaining || parseTimeRemaining(timeRemaining) > 15}
          >
            {t('JoinNow')}
          </button>
        )}
      </div>
    </div>
  );
};

export default Session;
